import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'
function AddRoomNo(){
    const [room, setRoom] = useState([]);
    const [rows, setRows] = useState([]);
    const [roomnoView,setRoomnoView] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [roomno,setRoomno]=useState({
        "room":'',
        "room_no":'',
        "status":'',
        "addedby":'',
        "ip_add":''
    });

    const handleChange = (event) => {
        setRoomno({
            ...roomno,
            [event.target.name]:event.target.value
        });
    }

    const formSubmit = () =>{
        const _formData = new FormData();
        _formData.append('room',roomno.room_id);
        _formData.append('room_no',roomno.room_no);
        _formData.append('status','1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        try{
            axios.post(baseUrl+'room-no/', _formData, {
                headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(function (response) {
               if(response.status==200 || response.status==201){
                    Swal.fire({
                        title: 'Data has been updated',
                        icon: 'success',
                        timer:5000,
                        showConfirmButton: false
                    });
               setTimeout(() => {
                  window.location.href = '/room-no/';
                }, 3000);
               }
            });
            }catch(error){
                console.log(error);
            }
        };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (roomnoView.length > 0) {
        setRows(roomnoView);
      }
  }, [roomnoView]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}room-no/`)
      .then(response => {
        setRoomnoView(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }
    useEffect(() => {
        try{
            axios.get(baseUrl+'room-type/')
            .then(function (response) {
                setRoom(response.data);
            });
        }catch(error){
            console.log(error);
        }
        },[]);
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-room-no/'+ id +'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                      window.location.href = '/room-no/';
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
  const columns = [
    { field: 'id', headerName: 'Id', width: 70 },
    {
      field: 'room',
      headerName: 'Rooms',
      width: 200,
      renderCell: (params) => params.row.room?.room || '',
    },
    { field: 'room_no', headerName: 'Room No', width: 500 },
    { field: 'addedby', headerName: 'Added By', width: 120},
    { field: 'edit', headerName: 'Edit',
        renderCell: (params) => (
          <Link to={`/edit-room-no/${params.row.id}`} target="_blank" className="btn btn-warning">
            Edit
          </Link>
      ),
      width: 120 },
      { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
      width: 120 },

  ];

    return (
        <section className="container mt-4">
            <div className="row">

              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Add Room No</h4>
                    <div className='card-body'>
                        <form>
                          <div className="mb-3">
                            <label htmlFor="room_id" className="form-label">Room Type</label>
                            <select name="room_id" value={roomno.room_id} onChange={handleChange} className="form-control">
                                <option>Select Room Type</option>
                                {room.map((type,index) => {return <option key={index} value={type.id}>{type.room}
                                </option>})}
                            </select>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="company" className="form-label">Room No</label>
                            <input type="text" className="form-control" name="room_no" value={roomno.room_no}
                            onChange={handleChange} id="room_no" />
                          </div>
                          <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
              </div>
            </div>


        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={rows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          </div>

        </section>

)
}

export default AddRoomNo;